import { Entity, OptimizerConfig, TrafficOptions } from '@nx-smartmonkey/shared/domain';
import { removeEmpty } from '@nx-smartmonkey/shared/helpers';
import { PlanStatus } from './PlanStatus';

export interface PlanFlatUpdateProps {
  label?: string;
  status?: PlanStatus;
  execution_date?: Date;
  optimizer_config?: OptimizerConfig;
  traffic_options?: TrafficOptions;
}

export interface PlanFlatProps {
  organization_id: string;
  project_id: string;
  status: PlanStatus;
  execution_date: Date;
  label?: string;
  optimizer_config?: OptimizerConfig;
  traffic_options?: TrafficOptions;
  completed_stops?: number;
  canceled_stops?: number;
  pending_stops?: number;
  incomplete_stops?: number;
  total_stops?: number;
  total_drivers?: number;
  deleted?: boolean;
  created_by?: string;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;
}

export class PlanFlat extends Entity<PlanFlatProps> {
  get id(): string {
    return this._id!;
  }
  get organization_id(): string {
    return this.props.organization_id;
  }
  get project_id(): string {
    return this.props.project_id;
  }
  get status(): PlanStatus {
    return this.props.status;
  }
  set status(status: PlanStatus) {
    this.props.status = status;
  }
  get execution_date(): Date {
    return this.props.execution_date;
  }
  set execution_date(execution_date: Date) {
    this.props.execution_date = execution_date;
  }
  get label(): string | undefined {
    return this.props.label;
  }
  set label(label: string | undefined) {
    this.props.label = label;
  }
  get optimizer_config(): OptimizerConfig | undefined {
    return this.props.optimizer_config;
  }
  set optimizer_config(optimizer_config: OptimizerConfig | undefined) {
    this.props.optimizer_config = optimizer_config;
  }
  get traffic_options(): TrafficOptions | undefined {
    return this.props.traffic_options;
  }
  set traffic_options(traffic_options: TrafficOptions | undefined) {
    this.props.traffic_options = traffic_options;
  }
  get completed_stops(): number | undefined {
    return this.props.completed_stops;
  }
  get canceled_stops(): number | undefined {
    return this.props.canceled_stops;
  }
  get pending_stops(): number | undefined {
    return this.props.pending_stops;
  }
  get total_stops(): number | undefined {
    return this.props.total_stops;
  }
  get total_drivers(): number | undefined {
    return this.props.total_drivers;
  }
  get incomplete_stops(): number | undefined {
    return this.props.incomplete_stops;
  }
  get deleted(): boolean | undefined {
    return this.props.deleted;
  }
  get created_by(): string | undefined {
    return this.props.created_by;
  }
  get created_at(): Date | undefined {
    return this.props.created_at;
  }
  get updated_at(): Date | undefined {
    return this.props.updated_at;
  }
  get deleted_at(): Date | undefined {
    return this.props.deleted_at;
  }

  update(props: PlanFlatUpdateProps) {
    removeEmpty(props);
    if (props.label) this.props.label = props.label;
    if (props.status) this.props.status = props.status!;
    if (props.execution_date) this.props.execution_date = props.execution_date!;
    if (props.optimizer_config) this.props.optimizer_config = props.optimizer_config;
    if (props.traffic_options) this.props.traffic_options = props.traffic_options;

    this.props.updated_at = new Date();
  }

  private constructor(props: PlanFlatProps, id?: string) {
    super(props, id);
  }
  static create(props: PlanFlatProps, id?: string) {
    return new PlanFlat(props, id);
  }
}
